import { Navigate, Outlet } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { getUserProfileService } from '@/shared/services/users.service';
import ROUTES from '@/shared/constants/routes';

/**
 * Puerta del área /dev-test en PRODUCCIÓN: herramientas internas (sandbox del
 * onboarding v3, mapas de flujo) visibles para el equipo sin levantar local.
 *
 * Regla: build dev = paso libre; en prod, sesión válida con correo del
 * dominio del equipo. El perfil se pide aquí mismo (con el token persistido)
 * porque /dev-test vive FUERA del shell autenticado y el profile de redux
 * puede no estar cargado. El dominio corporativo solo se obtiene entrando por
 * Google Workspace (o verificando el correo en esa bandeja), así que el check
 * de dominio equivale a "es del equipo" — el backend no expone el proveedor
 * de login, y no hace falta.
 */
const STAFF_EMAIL_DOMAIN = '@heru-app.com';

const DevTestGate = () => {
	const profileQuery = useQuery({
		queryKey: ['dev-test-staff-profile'],
		queryFn: getUserProfileService,
		enabled: !import.meta.env.DEV,
		retry: false,
		staleTime: Infinity,
	});

	if (import.meta.env.DEV) return <Outlet />;
	if (profileQuery.isLoading) return null;

	const email = (profileQuery.data as { email?: string } | undefined)?.email;
	const isStaff =
		typeof email === 'string' &&
		email.toLowerCase().endsWith(STAFF_EMAIL_DOMAIN);
	return isStaff ? <Outlet /> : <Navigate to={ROUTES.ROOT} replace />;
};

export default DevTestGate;
